import { Screen } from "../components/Screen";
import { Colors } from "../constants/colors";
import { CSSProperties, useEffect, useState } from "react";
import { Font } from "../constants/fonts";
import { Footer } from "../components/Footer";

export default function ComoFunciona() {
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (isMobile) {
        return (
            <Screen>
                <div style={mobileStyles.title}>
                    Simples, seguro e feito para você.
                </div>
                <div style={mobileStyles.legend}>
                    O ClikMob foi pensado para tornar o transporte mais prático e vantajoso. Veja como é fácil fazer parte dessa mudança:
                </div>
                
                <div style={mobileStyles.imageSection}>
                    <img src="/Group%2015.svg" alt="ClickMob funcionamento" style={mobileStyles.logo}/>
                </div>
                
                <div style={mobileStyles.stepsContainer}>
                    <div style={mobileStyles.step}>
                        <div style={mobileStyles.ordinalContainer}>
                            1
                        </div>
                        <div style={mobileStyles.stepContent}>
                            <div style={mobileStyles.stepTitle}>
                                <b>Baixe o aplicativo</b>  
                            </div>
                            <div style={mobileStyles.stepDescription}>
                                Disponível em breve nas principais plataformas.
                            </div>
                        </div>
                    </div>
                    
                    <div style={mobileStyles.step}>
                        <div style={mobileStyles.ordinalContainer}>
                            2
                        </div>
                        <div style={mobileStyles.stepContent}>
                            <div style={mobileStyles.stepTitle}>
                                <b>Cadastre-se como motorista ou passageiro</b>
                            </div>
                            <div style={mobileStyles.stepDescription}>
                                Tudo em poucos minutos, de forma simples e segura.
                            </div>
                        </div>
                    </div>
                    
                    <div style={mobileStyles.step}>
                        <div style={mobileStyles.ordinalContainer}>
                            3
                        </div>
                        <div style={mobileStyles.stepContent}>
                            <div style={mobileStyles.stepTitle}>
                                <b>Solicite sua corrida</b>
                            </div>
                            <div style={mobileStyles.stepDescription}>
                                Acompanhe em tempo real e sinta a diferença de um atendimento humanizado.
                            </div>
                        </div>
                    </div>
                    
                    <div style={mobileStyles.step}>
                        <div style={mobileStyles.ordinalContainer}>
                            4
                        </div>
                        <div style={mobileStyles.stepContent}>
                            <div style={mobileStyles.stepTitle}>
                                <b>Ganhe e acumule pontos ClikMob</b>
                            </div>
                            <div style={mobileStyles.stepDescription}>
                                Viaje, acumule pontos e troque por descontos em drogarias, bares, restaurantes e muito mais.
                            </div>
                        </div>
                    </div>
                </div>
                
                <Footer
                    backgroundColor={Colors.primary}
                    color={Colors.white}
                    image="/LOGO%20TM%203.svg"
                />
            </Screen>
        );
    }

    // Return original (desktop) intacto
    return (
        <Screen>
            <div style={styles.title}>
                Simples, seguro e feito para você.
            </div>
            <div style={styles.legend}>
                O ClikMob foi pensado para tornar o transporte mais prático e vantajoso. Veja como é fácil  fazer parte dessa mudança:
            </div>
            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.logoContainer}>
                        <img src="/Group%2015.svg" alt="ClickMob logo" style={styles.logo}/>
                    </div>
                </div>
                <div style={styles.container2}>
                    <div style={styles.line}>
                        <div style={styles.ordinalContainer}>
                            1
                        </div>
                        <div style={{width: '80%'}}>
                            <div style={styles.text}>
                                <b style={{marginBottom: 5}}>Baixe o aplicativo</b>  
                            </div>
                            <div style={styles.text}>
                                Disponível em breve nas principais plataformas.
                            </div>
                        </div>
                    </div>
                    <div style={styles.line}>
                        <div style={styles.ordinalContainer}>
                            2
                        </div>
                        <div style={{width: '80%'}}>
                            <div style={styles.text}>
                                <b style={{marginBottom: 5}}>Cadastre-se como motorista ou passageiro</b>
                            </div>
                            <div style={styles.text}>
                                Tudo em poucos minutos, de forma simples e segura.
                            </div>
                        </div>
                    </div>
                    <div style={styles.line}>
                        <div style={styles.ordinalContainer}>
                            3
                        </div>
                        <div style={{width: '80%'}}>
                            <div style={styles.text}>
                                <b style={{marginBottom: 5}}>Solicite sua corrida</b>
                            </div>
                            <div style={styles.text}>
                               Acompanhe em tempo real e sinta a diferença de um atendimento humanizado. 
                            </div>
                        </div>
                    </div>
                    <div style={styles.line}>
                        <div style={styles.ordinalContainer}>
                            4
                        </div>
                        <div style={{width: '80%'}}>
                            <div style={styles.text}>
                                <b style={{marginBottom: 5}}>Ganhe e acumule pontos ClikMob</b>
                            </div>
                            <div style={styles.text}>
                                Viaje, acumule pontos e troque por descontos em drogarias, bares, restaurantes e muito mais.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer
                backgroundColor={Colors.primary}
                color={Colors.white}
                image="/LOGO%20TM%203.svg"
            />
        </Screen>
    );
}

// Estilos desktop originais (mantidos intactos)
const styles: { [key: string]: CSSProperties } = {
    title: {
        marginTop: 70,
        marginBottom: 35,
        textAlign: 'center',
        fontSize: Font.title2.fontSize,
        fontWeight: Font.title2.fontWeight,
        color: Colors.primary
    },
    legend: {
        marginBottom: 150,
        textAlign: 'center',
        fontSize: Font.menu.fontSize,
        fontWeight: 'bold',
        color: Colors.primary
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 100
    },
    card: {
        width: '50%',
        height: 545,
        backgroundColor: Colors.primary,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'visible',
        position: 'relative',
        borderTopRightRadius: 100,
        borderBottomRightRadius: 100,
        marginBottom: 120
    },
    logo: {
        position: 'absolute',
        right: '20%',
        top: '50%',
        transform: 'translateY(-50%)',
        height: 675,
        width: 'auto',
        objectFit: 'contain',
        zIndex: 2,
        pointerEvents: 'none'
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    container2: {
        display: 'flex',
        flexDirection: 'column',
        width: '50%',
        gap: 90,
        marginTop: -90
    },
    line: {
        display: 'flex',
        flexDirection: 'row',
        gap: 20,
        width: '90%',
        alignItems: 'center'
    },
    ordinalContainer: {
        fontSize: Font.legend.fontSize,
        fontWeight: 'bold',
        color: Colors.white,
        backgroundColor: Colors.primary,
        borderRadius: 10,
        width: 55,
        height: 55,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        fontSize: Font.menu.fontSize,
        color: Colors.primary,
        textAlign: 'justify'
    }
}

// Estilos mobile otimizados
const mobileStyles: { [key: string]: CSSProperties } = {
    title: {
        marginTop: 40,
        marginBottom: 20,
        textAlign: 'center',
        fontSize: Font.title2.fontSize * 0.85,
        fontWeight: Font.title2.fontWeight,
        color: Colors.primary,
        padding: '0 20px',
        lineHeight: 1.3,
    },
    legend: {
        marginBottom: 40,
        textAlign: 'center',
        fontSize: Font.menu.fontSize * 0.95,
        fontWeight: 'bold',
        color: Colors.primary,
        padding: '0 20px',
        lineHeight: 1.4,
    },
    imageSection: {
        padding: '40px 20px',
        margin: '0 0 40px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomRightRadius: 60,
        borderBottomLeftRadius: 60,
    },
    logo: {
        width: '100%',
        maxWidth: 300,
        height: 'auto',
    },
    stepsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 40,
        padding: '0 20px 40px 20px',
        marginTop: 20,
    },
    step: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 20,
    },
    ordinalContainer: {
        fontSize: Font.legend.fontSize * 0.9,
        fontWeight: 'bold',
        color: Colors.white,
        backgroundColor: Colors.primary,
        borderRadius: 10,
        minWidth: 45,
        height: 45,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
    },
    stepContent: {
        flex: 1,
    },
    stepTitle: {
        fontSize: Font.menu.fontSize * 0.95,
        color: Colors.primary,
        marginBottom: 8,
        lineHeight: 1.3,
    },
    stepDescription: {
        fontSize: Font.menu.fontSize * 0.9,
        color: Colors.primary,
        lineHeight: 1.4,
    },
};